import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function ServicesPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Services - Equibre</title>
                <meta name="description" content="We're excited to collaborate with you on your next big project. Here’s how you can get started." />
            </Helmet>
            <section className="page-header-section services-zigzag-section">
                <div className="inner">
                    <div className="header">
                        <h1>Services</h1>
                        <p>We offer a wide range of services in software solutions including hosting.</p>
                    </div>
                    <div className="content">
                    <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder">
                                    <img src="/images/ai_dev.jpg" alt="AI/ML Solutions" />
                                </div>
                                <div className="text-holder">
                                    <div className="hdr">
                                        <div>
                                            <h1>AI/ML Solutions</h1>
                                        </div>
                                        <div>
                                            <p>We develop AI and ML solutions that make data work smarter—whether it’s automating tasks, analyzing patterns, or processing text, images, and video. From predictive models to intelligent automation, we help businesses build efficient, data-driven systems.</p>
                                        </div>
                                    </div>
                                    {/* <div>
                                        <ul>
                                            <li>- Experienced team</li>
                                            <li>- Your feedback prioritized</li>
                                            <li>- Weekly project updates</li>
                                            <li>- Timely delivery</li>
                                        </ul>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder">
                                    <img src="/images/custom_web_devimg.jpg" alt="Custom web development" />
                                </div>
                                <div className="text-holder">
                                    <div className="hdr">
                                        <div>
                                            <h1>Custom Web Development</h1>
                                        </div>
                                        <div>
                                            <p>Whether you have a business or a new startup idea, your website is often the first thing your users see. Our highly experienced team can create a website or service tailored to fit your business needs.</p>
                                        </div>
                                    </div>
                                    <div>
                                        <ul>
                                            <li>- Experienced team</li>
                                            <li>- Your feedback prioritized</li>
                                            <li>- Weekly project updates</li>
                                            <li>- Timely delivery</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder" style={{
                                    maxWidth: "600px",
                                    minWidth: "400px",
                                    width: "100%",
                                    height: "400px",
                                    overflow: "hidden"
                                }}>
                                    <img style={{position: "relative", top: -140}} src="/images/web_design_img.jpg" alt="Web designing" />
                                </div>
                                <div className="text-holder">
                                    <div>
                                        <h1>Web Designing</h1>
                                    </div>
                                    <div>
                                        <p>Our creative team specializes in delivering visually appealing and user-friendly web designs that make your brand stand out online.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder">
                                    <img src="/images/desktop_app_3.jpg" alt="Desktop app development" />
                                </div>
                                <div className="text-holder">
                                    <div>
                                        <h1>Desktop App Development</h1>
                                    </div>
                                    <div>
                                        <p>Our team develops high-performance desktop applications tailored to meet your specific business needs, ensuring seamless operation and user experience.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder" style={{
                                    maxWidth: "600px",
                                    minWidth: "400px",
                                    width: "100%",
                                    height: "400px",
                                    overflow: "hidden"
                                }}>
                                    <img style={{position: "relative", top: -200}} src="/images/mobile_app_dev.jpg" alt="Mobile app development" />
                                </div>
                                <div className="text-holder">
                                    <div>
                                        <h1>Mobile App Development</h1>
                                    </div>
                                    <div>
                                        <p>We create innovative and user-friendly mobile apps for both iOS and Android platforms, helping you reach your audience on the go.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder" style={{
                                    maxWidth: "600px",
                                    minWidth: "400px",
                                    width: "100%",
                                    height: "400px",
                                    overflow: "hidden"
                                }}>
                                    <img src="/images/hosting-img.jpg" alt="Hosting solution" />
                                </div>
                                <div className="text-holder">
                                    <div>
                                        <h1>Hosting Solutions</h1>
                                    </div>
                                    <div>
                                        <p>Our reliable hosting solutions ensure your website is always available, secure, and fast-loading for your users.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="service-zigzag">
                            <div className="inner">
                                <div className="img-holder">
                                    <img src="/images/domains_pic.jpg" alt="Domains solution" />
                                </div>
                                <div className="text-holder">
                                    <div>
                                        <h1>Domains Solutions</h1>
                                    </div>
                                    <div>
                                        <p>We offer comprehensive domain services, including registration, management, and protection, to establish and maintain your online presence.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ContactListSection />
        </>
    );
}